import {Stack, Grid, Typography, Divider} from '@mui/material';
import React from 'react';
import Image from 'next/image';

import {getSimpleBlurData} from '../../util';

import {useStyles} from './announcementBanner.styles';
import {AnnouncementBannerTypes} from './announcementBanner.types';

export const AnnouncementBanner = ({alertIcon, message, altText}: AnnouncementBannerTypes) => {
  const classes = useStyles();
  const testId = 'alert-banner-component';
  return (
    <>
      <Stack data-testid={testId} direction="row" className={classes.wrapperBox} tabIndex={0}>
        <Grid className={classes.homeContainer}>
          <Image
            src={alertIcon}
            data-testid="alert-icon"
            placeholder="blur"
            unoptimized
            priority={false}
            alt={altText}
            width={205}
            height={48}
            className={classes.iconImage}
            blurDataURL={getSimpleBlurData()}
          />
          <Typography variant="body1" className={classes.alertMessage}>
            {message}
          </Typography>
        </Grid>
      </Stack>
      <Divider orientation="horizontal" flexItem />
    </>
  );
};
